import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {Skeleton, SkeletonColorSchemesEnum} from '../../../../components/common/skeleton';
import {SeparatorsEnum} from '../../../helpers/analyticsExportHelpers';
import {ReportGridItem} from '../../reportViewer/reportGrid';
import {PaddedGridItemDiv, StyledLabelDiv} from './common';

/*
 * Props.
 */

export interface SeparatorConfig {
  value: SeparatorsEnum;
  title: ReactNode;
}

export interface ExportSeparatorInputProps {
  separatorConfigs: ReadonlyArray<SeparatorConfig>;
  selectedSeparator: SeparatorConfig;
  setSelectedSeparator: HandlerOf<SeparatorConfig>;
  isLoading?: boolean;
}

export const ExportSeparatorInput: FC<ExportSeparatorInputProps> = ({
  separatorConfigs,
  selectedSeparator,
  setSelectedSeparator,
  isLoading,
}) => {
  if (isLoading) {
    return renderLoadingState();
  }

  return (
    <PaddedGridItemDiv>
      {renderLabel()}

      <DropdownBoxCoordinator
        shouldDisablePadding
        value={selectedSeparator.title}
        renderDropdown={(popoverProps) => {
          const items = separatorConfigs.map((config) => (
            <SimpleDropdownItem
              key={config.value}
              onSelect={() => setSelectedSeparator(config)}
              isChecked={config.value === selectedSeparator.value}
            >
              {config.title}
            </SimpleDropdownItem>
          ));

          return <SimpleDropdown {...popoverProps}>{items}</SimpleDropdown>;
        }}
      />
    </PaddedGridItemDiv>
  );
};

/*
 * Helpers.
 */

function renderLabel() {
  return (
    <StyledLabelDiv>
      <Trans id="export-confirmation-label-separator">Separator</Trans>
    </StyledLabelDiv>
  );
}

function renderLoadingState() {
  return (
    <PaddedGridItemDiv>
      {renderLabel()}
      <ReportGridItem>
        <Skeleton width="100%" height="26px" borderRadius="6px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
    </PaddedGridItemDiv>
  );
}
